import { render, staticRenderFns } from "./Kontaktreiter.vue?vue&type=template&id=75a4b59c"
import script from "./Kontaktreiter.vue?vue&type=script&lang=js"
export * from "./Kontaktreiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports